// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePoolLeaveBody = {
  poolId: string;
};

export type typePoolLeaveOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { poolId: string; hasLeft: boolean };
};

export type typePoolLeaveOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolLeaveOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolLeaveOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPoolLeaveBody = {
  type: "object",
  properties: { poolId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPoolLeave(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPoolLeaveBody);
  }

  return async function postPoolLeave(
    payload: typePoolLeaveBody,
  ): Promise<typePoolLeaveOutput200 | typePoolLeaveOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPoolLeave" failed before calling the network. #d53ad5d48c16`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#d53ad5d48c16" },
        },
        data: null,
      } as typePoolLeaveOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pool/leave`,
      httpMethod: "POST",
      options,
    })) as typePoolLeaveOutput200 | typePoolLeaveOutput400;
  };
}
